module.exports = __webpack_public_path__ + "img/whatsApp.a1f7cf95.svg";